import { render, staticRenderFns } from "./UpdateMerchantCustomFeeModal.vue?vue&type=template&id=1eb2c4d3&scoped=true&"
import script from "./UpdateMerchantCustomFeeModal.vue?vue&type=script&lang=js&"
export * from "./UpdateMerchantCustomFeeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb2c4d3",
  null
  
)

export default component.exports